import { useSelector } from 'react-redux';

import { applicationStateSelectors } from 'store/slices/applicationState/selectors';

export const useProjectAssetType = () => {
  return useSelector(applicationStateSelectors.selectProjectAssetType);
};
